import { Entity, Field } from "typegraph";

@Entity({one: "", many: "tags"})
export default class TagSet {

	@Field()
	public id: string;

	@Field()
	public name: string;
}



// WEBPACK FOOTER //
// ./src/panels/recommended/entities/Tag.ts